import { render, staticRenderFns } from "./company-metadata-factoring.vue?vue&type=template&id=d76f8b08&scoped=true&lang=pug"
import script from "./company-metadata-factoring.vue?vue&type=script&lang=ts"
export * from "./company-metadata-factoring.vue?vue&type=script&lang=ts"
import style0 from "./company-metadata-factoring.vue?vue&type=style&index=0&id=d76f8b08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d76f8b08",
  null
  
)

export default component.exports